import React, { useState, useEffect, useCallback } from "react";
import { Container } from "react-bootstrap";
import { RouteComponentProps, useLocation } from "@reach/router";
import qs from "qs";
import { getUniversalReport, getOutliers } from "./../../utils/api";
import useDashboardData from "../../hooks/useDashboardData";
import { formatReportDate } from "../../utils/DataConversion";
import Isdh from "./Isdh";
import Ctsi from "./Ctsi";

// using existingData to distinguish old file / from new file

export default function Dashboard(props: RouteComponentProps) {
  const location = useLocation();

  const [vector, setVector] = useState<Data.Vectorized>();
  // for default data filtering please go to useDashboardData
  const [currentFilter, setCurrentFilter] = useState<App.CurrentFilter>({
    filterType: "state",
    displayName: "",
    filters: [],
  });
  const [dateFilter, setDateFilter] = useState<[number, number]>();
  const [outliers, setOutliers] = useState<Data.Outlier[]>();
  const [reportDate, setReportDate] = useState("");
  const [metricMapDate, setMetricMapDate] = useState("");

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const fetchVector = useCallback(async () => {
    const response = await getUniversalReport();
    setVector(response.data);
    setReportDate(response.reportDate);
    setMetricMapDate(formatReportDate(response.data.weekly_report_date));
  }, []);

  const fetchOutliers = useCallback(async () => {
    const response = await getOutliers();
    setOutliers(response.data);
  }, []);

  useEffect(() => {
    fetchVector();
    fetchOutliers();
  }, [fetchVector, fetchOutliers]);

  const { data: dashboardData } = useDashboardData({
    vectorizedData: vector,
    filter: currentFilter,
    dateFilter: dateFilter,
  });

  const resetFilter = () => {
    if (currentFilter && currentFilter.filterType === "county") {
      // todo - need to look at types of regionalRef
      //setCurrentFilter(regionalRef.current)
    } else {
      // todo - look at how show is being used
      setCurrentFilter({ filterType: "state", filters: [] });
    }
  };

  const commonProps = {
    dashboardData,
    reportDate,
    currentFilter,
    setCurrentFilter,
    dateFilter,
    setDateFilter,
    outliers,
    metricMapDate,
    resetFilter,
  };
  return (
    <Container fluid id="main-content" className="page-content mb-3">
      {queryParams.dash === "ctsi" ? (
        <Ctsi {...commonProps} />
      ) : (
        <Isdh {...commonProps} />
      )}
    </Container>
  );
}
